module.exports = __webpack_public_path__ + "static/Tax_Banner_63_Background.6a52eb2d.png";